module.exports = __webpack_public_path__ + "img/emoji_29.d7eef74f.png";